<template>
  <div>
    <v-card-title background-color="primary" class="
              pa-0
              pl-2
              text-sm-h6         
              text-md-h6          
              text-lg-h4      
              text-xl-h4
            ">
      <v-list-item-avatar size="35">
        <v-img :src="article.user.profile.profile_image"></v-img>
      </v-list-item-avatar> 
      <v-row>
        <v-col>
          <div>
            <v-bottom-sheet width="1200px" height="900px" v-model="sheet">
              <template v-slot:activator="{ on, attrs }">
                <v-btn elevation="0" v-bind="attrs" v-model="sheet" v-on="on" color="transparent" density="compact"
                  class="pl-0 pr-0">
                  <span class="
                            text-xs-caption         
                            text-sm-subtitle-2         
                            text-md-subtitle-2          
                            text-lg-subtitle-2      
                            text-xl-h6
                          ">
                    {{ createSubstr(article.user.first_name) + " " + (article.user.last_name) }}
                  </span>
                </v-btn>
              </template>
              <profilePage />
            </v-bottom-sheet>
            <div style="margin-top: -20px;">
              <span class="text-caption font-weight-light">
                <v-icon size="20">mdi-map-marker-multiple-outline</v-icon>
                  <a :href="'https://www.google.com/search?q=' + countryName" style="text-decoration:none; color: white"
                    target="_blank">{{ countryName }} </a>
                <!--<span>{{ countryEmoji }}</span>-->
              </span>
            </div>
          </div>
        </v-col>
      </v-row>
      <!--
      Will work on this function in the future. It was wokrking but I changed the code.
      -->
      <v-list-item-action>
        <v-switch inset v-model="cycle" append-icon="mdi-page-next" class="pa-0" color="white" hide-details></v-switch>
      </v-list-item-action>
      <v-card-actions>
        <span class="text-subtitle-2">
          {{ getTime(article.created_at) }}
        </span>
        <v-btn class="pl-2" x-small icon dark @click="handleCloseWindow">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card-title>
    <v-divider color="white" class="mx-0"></v-divider>
    <!-- This code will make the news toggle-->
    <!--@click="toggleNewsPageOverlay(); saveArticleAdress(article.url);">-->
    <!--<a :href="'' + article.files" target="_blank">-->
    <v-card-text class="pa-0" v-if="article.files === null"></v-card-text>
    <v-img v-if="article.files" :aspect-ratio="12 / 6" width="450" :src="article.files">
      <v-card v-if="article.files.includes('mp4' || 'mp3')">
        <video height="228" width="430" class="pa-0" controls muted autoplay>
          <source :src="article.files" />
          <v-btn color="white" text small class="white--text float-right"
            @click="overlay = true"><v-icon>mdi-eye-off-outline</v-icon>
          </v-btn>
          <v-overlay absolute width="500" :opacity="opacity" :value="overlay">
            <p class="text-md-center"><v-icon>mdi-eye-off</v-icon>
            </p>
            <p class="text-md-center">Content Warning: Sensitive Content.<br />
              Triyangle flagged this post for sensitive content.<br />
            </p>
            <v-btn color="white" text small outlined rounded class="white--text float-right" @click="overlay = false">
              Show
            </v-btn>
          </v-overlay>
        </video>
      </v-card>
      <v-dialog v-model="imgDialog" width="920" persistent>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="!article.files.includes('mp4' || 'mp3')" v-bind="attrs" v-on="on" elevation="0"
            color="transparent" class="maximize-button" @click="maximizeImage = true">
            <v-icon size="30">mdi-fullscreen</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-img :lazy-src="article.files" :src="article.files">
            <v-btn elevation="0" class="close-button" color="transparent" @click="imgDialog = false" size="30">
              <v-icon color="white">mdi-close
              </v-icon>
            </v-btn>
          </v-img>
        </v-card>
      </v-dialog>
    </v-img>
    <!--</a>-->
    <v-card-text class="pa-0" v-if="showCommentSection">
      <commentSection :comments="article.comments" />
    </v-card-text>
    <v-card-text
      v-else 
      class="
        contentArea 
        white--text 
        font-weight-bold 
        text-caption pl-3 pr-3 pt-1 
        max-height-v-card"
    >
      {{ article.content }}
      <a :href="'' + article.link" target="_blank">{{ article.link }}</a>
      <v-row>
        <v-col cols="12" md="12">
          <v-select
            append-icon="mdi-translate-variant"
            clearable
            style="font-size: 14px"
            :items="languages"
            label="Translate to:"
            v-model="selectedLanguage"
            :item-text="name"
            :item-value="code"
            filled
            dense
            @change="translate(article.id)"
          ></v-select>
          <v-card 
            class="pb-0 pt-0"
            elevation="0" 
            style="background-color:rgb(255, 255, 255, 0.001)" 
            v-if="translatedText && selectedLanguage"
          >
            <v-card-text class="
              white--text 
              font-weight-bold 
              text-caption pl-1 pt-0 pr-1 pt-0"
              >
              {{ translatedText }}
              <a :href="'' + article.link" target="_blank">{{ article.link }}</a>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="pa-0 pt-0 buttonsArea">
      <v-list-item>
        <v-row align="center" justify="end" class="pr-2">
          <v-icon class="mr-1">
            mdi-eye-outline
          </v-icon>
          <span class="subheading mr-2">{{ article.views }}</span>
          <span class="mr-2">·</span>
          <v-icon v-if="showCommentSection" @click="toggleCommentSection">
            mdi-post-outline
          </v-icon>
          <v-icon v-else class="mr-1" @click="toggleCommentSection">
            mdi-comment-multiple-outline
          </v-icon>
          <span class="subheading mr-2">{{ article.comments.length }}</span>
          <span class="mr-1">·</span>
          <!--<likeButton :articleId="article.id"/>-->
          <v-btn @click="likePost(article.id)" :liked="true" elevation="0" color="transparent" fab
            small>
            <v-icon :color="liked ? 'red' : 'none'">
              {{ liked ? 'mdi-heart' : 'mdi-heart-outline' }}
            </v-icon>
          </v-btn>
          <span class="subheading mr-2">{{ totalLikes }}</span>
          <span>·</span>
          <!--This section will be used for repost when the time comes.-->
          <v-btn  @click="repost(article.id)" :reposted="true" color="transparent" elevation="0" fab small>
            <v-icon :color="reposted ? 'red' : 'none'">
              mdi-selection-marker
            </v-icon>
          </v-btn>
          <span class="subheading mr-2">{{ totalRepost }}</span>
          <span>·</span>
          <v-speed-dial v-model="fab">
            <template v-slot:activator>
              <v-btn v-model="fab" color="transparent" elevation="0" dark fab small>
                <v-icon v-if="fab">
                  mdi-close
                </v-icon>
                <v-icon v-else>
                  mdi-share-variant
                </v-icon>
              </v-btn>
            </template>
            <v-btn fab dark small color="primary">
              <a :href="'https://www.linkedin.com/sharing/share-offsite/?url=' + article.link" target="_blank">
                <v-icon color="white">mdi-linkedin</v-icon>
              </a>
            </v-btn>
            <v-btn fab dark small color="green">
              <a :href="'https://api.whatsapp.com/send?text=' + article.link" target="_blank"
                data-action="share/whatsapp/share">
                <v-icon color="white">mdi-whatsapp</v-icon>
              </a>
            </v-btn>
            <v-btn fab dark small color="primary">
              <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + article.link" target="_blank">
                <v-icon color="white">mdi-facebook</v-icon>
              </a>
            </v-btn>
          </v-speed-dial>
          <span class="subheading">{{ article.shares }}</span>
        </v-row>
      </v-list-item>
    </v-card-actions>
    <v-divider color="lightblue"></v-divider>
    <v-card class="ml-0 pb-1 pt-0 rounded-t-0" color="#1565C0" fluid max-width="500" max-height="400" dark>
      <v-card-actions class="pb-0">
        <v-list-item>
          <v-bottom-sheet width="1200px" v-model="sheet">
            <template v-slot:activator="{ on, attrs }">
              <v-btn small class="pl-0 pr-0" elevation="0" v-bind="attrs" v-model="sheet" v-on="on" color="transparent"
                density="compact" box-shadow="0px" @click="toggleProfilePage">
                <v-list-item-avatar size="40" class="v-img">
                  <v-img :src="profile_image" alt="avatar"></v-img>
                </v-list-item-avatar>
              </v-btn>
            </template>
            <profilePage />
          </v-bottom-sheet>
          <v-textarea type="text" v-model="comment" clear-icon="mdi-close-circle" @click:append="addComment(article.id)"
            @keyup.enter="addComment(article.id)" placeholder="What are your thoughts?" clearable auto-grow counter
            filled class="
                    text-overline max-height-textarea white--text" rows="1" rounded dense hide-details>
          </v-textarea>
          <v-list-item-action>
            <v-dialog v-model="dialog" width="800">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" small color="red" dark>
                  <v-icon>mdi-currency-usd</v-icon>
                </v-btn>
              </template>
              <donationLink />
            </v-dialog>
          </v-list-item-action>
        </v-list-item>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import { translateText } from "@/services/translationService";
import commentSection from './commentSection'
import profilePage from './profilePage'
//import likeButton from './likeButton'
// import profilePost from './profilePost'
import donationLink from './donationLink'
import { apiUrl } from '../config'
// import PostDetails from './postDetails.vue'

const moment = require('moment')
moment().format()
export default {
  data: () => ({
    inputText: '',
      translatedText: '',
      selectedLanguage: '',
      languages: [
        { text: 'Afrikaans', value: 'af' },
        { text: 'Albanian', value: 'sq' },
        { text: 'Amharic', value: 'am' },
        { text: 'Arabic', value: 'ar' },
        { text: 'Armenian', value: 'hy' },
        { text: 'Azerbaijani', value: 'az' },
        { text: 'Basque', value: 'eu' },
        { text: 'Belarusian', value: 'be' },
        { text: 'Bengali', value: 'bn' },
        { text: 'Bosnian', value: 'bs' },
        { text: 'Bulgarian', value: 'bg' },
        { text: 'Catalan', value: 'ca' },
        { text: 'Cebuano', value: 'ceb' },
        { text: 'Chinese (Simplified)', value: 'zh-CN' },
        { text: 'Chinese (Traditional)', value: 'zh-TW' },
        { text: 'Corsican', value: 'co' },
        { text: 'Croatian', value: 'hr' },
        { text: 'Czech', value: 'cs' },
        { text: 'Danish', value: 'da' },
        { text: 'Dutch', value: 'nl' },
        { text: 'English', value: 'en' },
        { text: 'Esperanto', value: 'eo' },
        { text: 'Estonian', value: 'et' },
        { text: 'Finnish', value: 'fi' },
        { text: 'French', value: 'fr' },
        { text: 'Frisian', value: 'fy' },
        { text: 'Galician', value: 'gl' },
        { text: 'Georgian', value: 'ka' },
        { text: 'German', value: 'de' },
        { text: 'Greek', value: 'el' },
        { text: 'Gujarati', value: 'gu' },
        { text: 'Haitian Creole', value: 'ht' },
        { text: 'Hausa', value: 'ha' },
        { text: 'Hawaiian', value: 'haw' },
        { text: 'Hebrew', value: 'he' },
        { text: 'Hindi', value: 'hi' },
        { text: 'Hmong', value: 'hmn' },
        { text: 'Hungarian', value: 'hu' },
        { text: 'Icelandic', value: 'is' },
        { text: 'Igbo', value: 'ig' },
        { text: 'Indonesian', value: 'id' },
        { text: 'Irish', value: 'ga' },
        { text: 'Italian', value: 'it' },
        { text: 'Japanese', value: 'ja' },
        { text: 'Javanese', value: 'jv' },
        { text: 'Kannada', value: 'kn' },
        { text: 'Kazakh', value: 'kk' },
        { text: 'Khmer', value: 'km' },
        { text: 'Kinyarwanda', value: 'rw' },
        { text: 'Korean', value: 'ko' },
        { text: 'Kurdish', value: 'ku' },
        { text: 'Kyrgyz', value: 'ky' },
        { text: 'Lao', value: 'lo' },
        { text: 'Latin', value: 'la' },
        { text: 'Latvian', value: 'lv' },
        { text: 'Lithuanian', value: 'lt' },
        { text: 'Luxembourgish', value: 'lb' },
        { text: 'Macedonian', value: 'mk' },
        { text: 'Malagasy', value: 'mg' },
        { text: 'Malay', value: 'ms' },
        { text: 'Malayalam', value: 'ml' },
        { text: 'Maltese', value: 'mt' },
        { text: 'Maori', value: 'mi' },
        { text: 'Marathi', value: 'mr' },
        { text: 'Mongolian', value: 'mn' },
        { text: 'Myanmar (Burmese)', value: 'my' },
        { text: 'Nepali', value: 'ne' },
        { text: 'Norwegian', value: 'no' },
        { text: 'Nyanja (Chichewa)', value: 'ny' },
        { text: 'Odia (Oriya)', value: 'or' },
        { text: 'Pashto', value: 'ps' },
        { text: 'Persian', value: 'fa' },
        { text: 'Polish', value: 'pl' },
        { text: 'Portuguese', value: 'pt' },
        { text: 'Punjabi', value: 'pa' },
        { text: 'Romanian', value: 'ro' },
        { text: 'Russian', value: 'ru' },
        { text: 'Samoan', value: 'sm' },
        { text: 'Scots Gaelic', value: 'gd' },
        { text: 'Serbian', value: 'sr' },
        { text: 'Sesotho', value: 'st' },
        { text: 'Shona', value: 'sn' },
        { text: 'Sindhi', value: 'sd' },
        { text: 'Sinhala', value: 'si' },
        { text: 'Slovak', value: 'sk' },
        { text: 'Slovenian', value: 'sl' },
        { text: 'Somali', value: 'so' },
        { text: 'Spanish', value: 'es' },
        { text: 'Sundanese', value: 'su' },
        { text: 'Swahili', value: 'sw' },
        { text: 'Swedish', value: 'sv' },
        { text: 'Tagalog (Filipino)', value: 'tl' },
        { text: 'Tajik', value: 'tg' },
        { text: 'Tamil', value: 'ta' },
        { text: 'Tatar', value: 'tt' },
        { text: 'Telugu', value: 'te' },
        { text: 'Thai', value: 'th' },
        { text: 'Turkish', value: 'tr' },
        { text: 'Turkmen', value: 'tk' },
        { text: 'Ukrainian', value: 'uk' },
        { text: 'Urdu', value: 'ur' },
        { text: 'Uyghur', value: 'ug' },
        { text: 'Uzbek', value: 'uz' },
        { text: 'Vietnamese', value: 'vi' },
        { text: 'Welsh', value: 'cy' },
        { text: 'Xhosa', value: 'xh' },
        { text: 'Yiddish', value: 'yi' },
        { text: 'Yoruba', value: 'yo' },
        { text: 'Zulu', value: 'zu' }
    ],
    API_URL: apiUrl,
    opacity: 1,
    maximizeImage: false,
    alert: true,
    cycle: false,
    overlay: false,
    postProfileData: [''],
    profile_image: '',
    fab: "",
    onboarding: 0,
    showCommentSection: false,
    showNewsPage: false,
    showProfilePage: false,
    dialog: false,
    imgDialog: false,
    comment: "",
    comments: [],
    // new like variables //
    liked: false,
    // end of like variables //
    postLike: false,
    // totalLikes: this.article.likes,
    totalLikes: 0,
    totalRepost: 0,
    reposted: false,
    articleAddress: "",
    fullScreen: false,
    sheet: "",
  }),

  components: {
    commentSection,
    profilePage,
    // profilePost,
    donationLink,
    //likeButton,
    // PostDetails,
  },
  methods: {
   async translate(articleId) {
      try {
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];
        console.log(authToken);

        const response = await axios.get(`${this.API_URL}posts/${articleId}`,
          {
            headers: {
              Authorization: authToken
            }
          }
        );
        console.log(response.data)
        this.textToTranslate = response.data.content;
      } catch (error) {
        console.error('Error getting post content, status:', error);
      }
      if (this.textToTranslate && this.selectedLanguage) {
        try {
          this.translatedText = await translateText(this.textToTranslate, this.selectedLanguage);
        } catch (error) {
          this.translatedText = 'Error translating text';
        }
      } else {
        this.translatedText = 'Please enter text and select a language';
      }
    },
    async getProfileData() {
      try {
        // fetch profile
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];

        console.log(authToken)
        console.log('API URL', this.API_URL)
        const response = await axios.get(`${this.API_URL}users/current-user/`, {
          headers: {
            'Authorization': authToken,
          },
        })
        // set the data returned as profile
        this.postProfileData = response.data;
        this.profile_image = this.postProfileData?.profile.profile_image;
        console.log(this.postProfileData);

      } catch (error) {
        // log the error
        console.log(error);
      }
    },
    // Post like method
    handleCloseWindow() {
      this.$emit('trigger-close-window')
    },
    toggleProfilePage() {
      this.showProfilePage = !this.showProfilePage;
    },
    // next() {
    //   this.onboarding =
    //     this.onboarding + 1 === this.length ? 0 : this.onboarding + 1
    // },
    // prev() {
    //   this.onboarding =
    //     this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1
    // },
    // Will be used to post the time each article was posted.
    //
    getTime(publishedDate) {
      // Get todays date and the published date and find out how long
      // it's being since the article was posted.
      //
      //const m1 = new Date(); // prints: Toady's date
      console.log(publishedDate)
      const m2 = new Date(publishedDate) // prints: Date of article
      const timeFromNow = moment(m2).fromNow() // Returns date that article was created
      return timeFromNow
    },
    createSubstr(authors) {
      console.log(authors)
      if (authors === undefined) {
        return ""
      }
      return authors.substr(0, 22)
    },
    // post like
    //
    async likePost(postId) {
      try {

        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];
        console.log(authToken);

        const response = await axios.post(
          `${this.API_URL}posts/${postId}/toggle-like`,{}, // An empty object as the body, since the API might not require any
          {
            headers: {
              Authorization: authToken
            }
          }
        );
        // Assuming the API returns a boolean or an object with a field like `liked`
        console.log(response)

        if (response.status === 200) {
          this.totalLikes = response.data.likes_count
          this.liked = response.data.is_liked;
        }
      } catch (error) {
        console.error('Error checking user like status:', error);
      }
    },
    // repost method
    async repost(postId) {
      try {
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];
        //console.log(authToken);
        //console.log(this.API_URL);  
        const response = await axios.post(`${this.API_URL}posts/${postId}/toggle-repost`, {}, {
          headers: { Authorization: authToken },
        });
        if (response.status === 200) {
          this.totalRepost = response.data.reposts_count
          this.reposted = response.data.is_repost;
        }
      } catch (error) {
        console.error('Error reposting:', error);
      }
    },

    // for adding and rendering comments...
    async addComment(postId) {
      console.log(postId);
      console.log(this.comment);

      if (!this.comment) return;

      const newComment = {
        text: this.comment
      };

      let user = localStorage.getItem('user');
      user = JSON.parse(user);

      const authToken = 'Bearer ' + user['access'];
      console.log(authToken);

      try {
        const response = await axios.post(
          `${this.API_URL}posts/${postId}/comments/`,
          newComment,
          {
            headers: {
              Authorization: authToken
            }
          }
        );
        console.log(response);

        // Emit only when the comment is successfully added
        if (response.status === 201) {
          this.$emit('trigger-refresh-posts');
        }
      } catch (error) {
        console.log(error);
      }

      this.comment = "";
    },
    toggleCommentSection() {
      this.showCommentSection = !this.showCommentSection;
    },
    saveArticleAdress(url) {
      this.articleAddress = url;
    },
    toggleNewsPageOverlay() {
      this.showNewsPage = !this.showNewsPage;
    },
    async checkUserLike() {
      try {

        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];
        console.log(authToken);

        const response = await axios.get(`${this.API_URL}posts/${this.article.id}/user-like-check`,
          {
            headers: {
              Authorization: authToken
            }
          }
        );
        // Assuming the API returns a boolean or an object with a field like `liked`
        console.log(response.data)
        this.liked = response.data.liked;
      } catch (error) {
        console.error('Error checking user like status:', error);
      }
    },
    async checkRepostLike() {
      try {

        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];
        console.log(authToken);

        const response = await axios.get(`${this.API_URL}posts/${this.article.id}/user-repost-check`,
          {
            headers: {
              Authorization: authToken
            }
          }
        );
        // 
        console.log(response.data)
        this.reposted = response.data.reposted; 
      } catch (error) {
        console.error('Error checking user like status:', error);
      }
    },
    // toggleFullScreen() {
    //   this.fullScreen = !this.fullScreen
    // }
  },
  props: {
    article: Object,
    countryName: String,
  },

  created() {
    this.totalLikes = this.article.likes
    this.totalRepost = this.article.reposts
    this.getProfileData()
    this.checkUserLike()
    this.checkRepostLike()
  },
}
</script>

<style>
.maximize-button {
  position: absolute;
  bottom: 10px;
  right: 1px;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 1px;
}

.max-height-textarea textarea {
  max-height: 105px;
  /* Adjust the desired maximum height here */
  overflow: auto;
}

.max-height-v-card {
  overflow: auto;
  max-height: 140px
}

.full-screen {
  width: 100% !important;
  height: 100% !important;
  top: 50% !important;
  bottom: 0 !important;
}

a:visited {
  color: deepskyblue;
  background-color: transparent;
  text-decoration: none;
}
</style>